import { Routes } from '@angular/router';
import { authGuard, guestGuard, permissionGuard } from '@shared';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./components/auth/admin-login/admin-login.component').then(
        (m) => m.AdminLoginComponent
      ),
    canActivate: [guestGuard],
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./components/auth/admin-forgot-password/admin-forgot-password.component').then(
        (m) => m.AdminForgotPasswordComponent
      ),
    canActivate: [guestGuard],
  },
  {
    path: 'recover-password',
    loadComponent: () =>
      import('./components/auth/admin-recover-password/admin-recover-password.component').then(
        (m) => m.AdminRecoverPasswordComponent
      ),
    canActivate: [guestGuard],
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import(
        './components/no-auth/admin-terms-and-conditions/admin-terms-and-conditions.component'
      ).then((m) => m.AdminTermsAndConditionsComponent),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./components/no-auth/admin-privacy-policy/admin-privacy-policy.component').then(
        (m) => m.AdminPrivacyPolicyComponent
      ),
  },
  {
    path: 'account',
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/account/dashboard/dashboard.component').then(
            (m) => m.AdminDashboardComponent
          ),
        data: { breadcrumb: 'ADMIN.ADMIN-DASHBOARD.BREADCRUM' },
        children: [],
      },
      {
        path: 'profiles-permissions-managers',
        data: {
          breadcrumb: 'Perfiles y permisos de gestores',
          permissions: [['userAdminType', 'getUserGestorTypeList']],
        },
        canActivate: [permissionGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './components/account/profiles-permissions-managers/profiles-permissions-managers.component'
              ).then((m) => m.ProfilesPermissionsManagersComponent),
          },
          {
            path: 'edit/:id',
            data: {
              breadcrumb: 'Editar perfil',
              permissions: [['userAdminType', 'updateUserGestorType']],
            },
            canActivate: [permissionGuard],
            children: [],
            loadComponent: () =>
              import(
                './components/account/profile-permissions-managers/profile-permissions-managers.component'
              ).then((m) => m.ProfilePermissionsManagersComponent),
          },
          {
            path: 'create',
            data: {
              breadcrumb: 'Crear perfil',
              permissions: [['userAdminType', 'createUserGestorType']],
            },
            canActivate: [permissionGuard],
            children: [],
            loadComponent: () =>
              import(
                './components/account/profile-permissions-managers/profile-permissions-managers.component'
              ).then((m) => m.ProfilePermissionsManagersComponent),
          },
        ],
      },
      {
        path: 'profiles-permissions-admins',
        data: {
          breadcrumb: 'Perfiles y permisos de administradores',
          permissions: [['userAdminType', 'getUserAdminTypeList']],
        },
        canActivate: [permissionGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './components/account/profiles-permissions-admins/profiles-permissions-admins.component'
              ).then((m) => m.ProfilesPermissionsAdminsComponent),
          },
          {
            path: 'edit/:id',
            data: {
              breadcrumb: 'Editar perfil',
              permissions: [['userAdminType', 'updateUserAdminType']],
            },
            canActivate: [permissionGuard],
            children: [],
            loadComponent: () =>
              import(
                './components/account/profile-permissions-admins/profile-permissions-admins.component'
              ).then((m) => m.ProfilePermissionsAdminsComponent),
          },
          {
            path: 'create',
            data: {
              breadcrumb: 'Crear perfil',
              permissions: [['userAdminType', 'createUserAdminType']],
            },
            canActivate: [permissionGuard],
            children: [],
            loadComponent: () =>
              import(
                './components/account/profile-permissions-admins/profile-permissions-admins.component'
              ).then((m) => m.ProfilePermissionsAdminsComponent),
          },
        ],
      },
      {
        path: 'users',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./components/account/users/users.component').then((m) => m.UsersComponent),
        data: {
          breadcrumb: 'Usuarios del sistema',
          permissions: [['userAdminType', 'getUserAdminList']],
        },
        children: [],
      },
      {
        path: 'residential-developments',
        data: {
          breadcrumb: 'Fraccionamientos',
          permissions: [['userAdminType', 'getResidentialList']],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './components/account/residential-developments/residential-developments.component'
              ).then((m) => m.ResidentialDevelopmentsComponent),
          },
          {
            path: 'create',
            data: {
              breadcrumb: 'Nuevo Fraccionamiento',
              permissions: [['userAdminType', 'createResidential']],
            },
            canActivate: [permissionGuard],
            loadComponent: () =>
              import(
                './components/account/residential-development/residential-development.component'
              ).then((m) => m.ResidentialDevelopmentComponent),

            children: [],
          },
          {
            path: 'edit/:id',
            loadComponent: () =>
              import(
                './components/account/residential-development/residential-development.component'
              ).then((m) => m.ResidentialDevelopmentComponent),
            data: {
              breadcrumb: 'Editar Fraccionamiento',
              permissions: [['userAdminType', 'updateResidential']],
            },
            canActivate: [permissionGuard],
            children: [],
          },
          {
            path: 'managers/:id',
            loadComponent: () =>
              import(
                './components/account/managers-residential-development/managers-residential-development.component'
              ).then((m) => m.ManagersResidentialDevelopmentComponent),
            data: {
              breadcrumb: 'Gestores',
              permissions: [['userAdminType', 'getUserGestorListByResidentialId']],
            },
            canActivate: [permissionGuard],
            children: [],
          },
        ],
      },
    ],
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
];
